export const DOWNLOAD_SKILL_ANCHOR = 'download-skill'
export const DOWNLOAD_REPOSITORY_ANCHOR = 'download-repository'
